import { features } from 'config/features';
import styles from './_CompanyAndTitle.module.scss';
import SrsLogo from './images/srs-logo.svg';
import UobLogo from './images/uob-logo.svg';

const CompanyAndTitle = () => {
    return (
        <div className={styles.wrapper}>
            {features.hasBrand && (
                <img src={UobLogo} alt="" className={styles.uobLogo} />
            )}
            <img src={SrsLogo} alt="" />
        </div>
    );
};

export default CompanyAndTitle;
